import { useState } from "react";

const defaultFaqs = [
  {
    id: 1,
    question: "How long does verification take?",
    answer:
      "Most leads clear in under 5 minutes. Files needing manual review are flagged the same working day.",
  },
  {
    id: 2,
    question: "What happens if a lender rejects the lead?",
    answer:
      "The lead is automatically rerouted to the next suitable lender based on the profile and eligibility.",
  },
  {
    id: 3,
    question: "When is commission paid?",
    answer:
      "Commission is calculated on the successful disbursal and paid according to the applicable payout cycle.",
  },
  {
    id: 4,
    question: "How are disputes handled?",
    answer:
      "Disputes are reviewed against the lead activity, verification records, lender status and disbursal information.",
  },
];

function FAQ({ faqs = defaultFaqs, label = "FAQ", dark = false }) {
  const [openIds, setOpenIds] = useState([]);

  const toggleFAQ = (id) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <section
      className={`overflow-hidden section-spacing ${
        dark ? "bg-[#191e1c]" : "bg-[#ffffff]"
      }`}
    >
      <div className="section-container">
        {/* Section label */}
        <p className={`font-jakarta text-[11px] sm:text-[12px] font-medium tracking-[0.34em] uppercase mb-2.5 ${dark ? "text-[var(--mint-green)]" : "text-[var(--hero-green)]"}`}>
          {label}
        </p>

        {/* FAQ list */}
        <div
          className={`mt-8 border-t ${
            dark ? "border-white/10" : "border-[#d6ded9]"
          }`}
        >
          {faqs.map((faq) => {
            const isOpen = openIds.includes(faq.id);

            return (
              <div
                key={faq.id}
                className={`border-b ${
                  dark ? "border-white/10" : "border-[#d6ded9]"
                }`}
              >
                {/* Question */}
                <button
                  type="button"
                  onClick={() => toggleFAQ(faq.id)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${faq.id}`}
                  className="group flex w-full items-center justify-between gap-6 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--mint-green)] focus-visible:ring-offset-2 sm:py-7 cursor-pointer"
                >
                  <span
                    className={`font-bricolage text-[18px] font-medium leading-[1.25] tracking-[-0.3px] sm:text-[20px] ${
                      dark ? "text-[#f4f7f5]" : "text-[#0b1720]"
                    }`}
                  >
                    {faq.question}
                  </span>

                  <span
                    aria-hidden="true"
                    className="shrink-0 font-jakarta text-[19px] font-medium leading-none text-[var(--mint-green)] transition-transform duration-200"
                  >
                    {isOpen ? "×" : "+"}
                  </span>
                </button>

                {/* Answer */}
                <div id={`faq-answer-${faq.id}`} hidden={!isOpen}>
                  <div className="pb-7 pr-10 sm:pb-8 sm:pr-14">
                    <p
                      className={`font-jakarta text-[15px] leading-[1.65] sm:text-[16px] ${
                        dark ? "text-[#9fa9a5]" : "text-[#53616a]"
                      }`}
                    >
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
